<template>
    <div>
        <div class="row" style="flex-wrap: wrap;">
            <div class="col-lg-12">
                <card>
                    <div class="row">
                        <div
                            class="col-10 d-flex justify-content-center align-items-center justify-content-sm-between flex-wrap">
                            <div>
                                <el-select clearable class="filter-select mr-2" v-model="filters.year"
                                           placeholder="Filter by year" @change="applyFilters">
                                    <el-option v-for="item in filterOptions.years" clearable :key="item.value" :label="item.text"
                                               :value="item.value"/>
                                </el-select>
                                <el-select clearable class="filter-select mr-2" v-model="filters.regionId"
                                           placeholder="Filter by region" @change="applyFilters">
                                    <el-option v-for="item in filterOptions.regions" :key="item.value" clearable
                                               :label="item.text" :value="item.value"/>
                                </el-select>
                                <el-select clearable class="filter-select mr-2" v-model="filters.stage"
                                           placeholder="Filter by stage" @change="applyFilters">
                                    <el-option v-for="item in filterOptions.stages" :key="item.value" :label="item.text" clearable
                                               :value="item.value"/>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-2">
                            <base-button @click="exportExcell()" type="default" size="lg" class="btn-fill pull-right">
                                Export
                            </base-button>
                        </div>
                    </div>
                </card>
            </div>
            <!-- Stats Cards -->
            <div class="col-lg-3 col-md-6" v-for="(card, index) in statsCards" :key="index">
                <stats-card
                    :title="card.title"
                    :sub-title="card.subTitle"
                    :type="card.type"
                    :icon="card.icon"
                >
                    <div slot="footer" v-html="card.footer"></div>
                </stats-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    v-if="filters.stage !== 'Concept Note'"
                    :items="dashboardData.totalOrganisation"
                    :title="$t('dashboard_admin.type_of_organization')"
                >
                </chart-card>
                <chart-card
                    v-if="filters.stage === 'Concept Note'"
                    :items="dashboardData.totalOrganisation"
                    :title="$t('dashboard_admin.concept_note_type_of_organization')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    v-if="filters.stage === 'Concept Note'"
                    :items="dashboardData.totalOrganisationWithCoApplicant"
                    :title="$t('dashboard_admin.type_of_organization_with_co_applicant')"
                >
                </chart-card>
                <chart-card
                    v-if="filters.stage !== 'Concept Note'"
                    :items="dashboardData.totalOrganisationWithCoApplicant"
                    :title="$t('dashboard_admin.type_of_organization_with_co_applicant_full_proposal')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    :items="dashboardData.totalObjectives"
                    :title="$t('dashboard_admin.number_of_applications_per_main_objective')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    :items="dashboardData.totalSecondObjectives"
                    :title="$t('dashboard_admin.number_of_applications_per_second_objective')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    :items="dashboardData.totalMainTypeOfIntervention"
                    :title="$t('dashboard_admin.number_of_applications_per_main_type_of_intervention')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    :items="dashboardData.totalOtherTypeOfIntervention"
                    :title="$t('dashboard_admin.number_of_applications_per_other_type_of_intervention')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    :items="dashboardData.totalMainInterventionArea"
                    :title="$t('dashboard_admin.number_of_applications_per_main_area_of_intervention')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    :items="dashboardData.totalOtherInterventionArea"
                    :title="$t('dashboard_admin.number_of_applications_per_other_area_of_intervention')"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    v-if="filters.stage !== 'Concept Note'"
                    :items="dashboardData.totalSdg"
                    :title="$t('dashboard_admin.number_of_applications_addressing_the_sdgs_target')"
                    :has-total="false"
                >
                </chart-card>
            </div>
            <div class="col-lg-12">
                <chart-card
                    v-if="filters.stage !== 'Concept Note'"
                    :items="dashboardData.totalTargets"
                    :title="$t('dashboard_admin.number_of_applications_addressing_the_aichi_targets')"
                    :has-total="false"
                >
                </chart-card>
            </div>
        </div>
    </div>
</template>
<script>
import ListCard from './ListCard';
import ChartCard from "./Cards/ChartCard";
import StatsCard from 'src/components/Cards/StatsCard';
import Card from 'src/components/Cards/Card';
import {
    Select,
    Option
} from "element-ui";
import {DashboardService, RegionService} from '@/services';

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        StatsCard,
        ListCard,
        ChartCard,
        Card
    },
    data() {
        return {
            dashboardData: {},
            statsCards: [],
            regions: [],
            filterOptions: {},
            filters: {
                regionId: "",
                year: "",
                stage: "Full Proposal",
            },
            chartData: {
                datasets: [{
                    backgroundColor: ['#ff6384', '#ffcd56', '#36a2eb', '#8ceb36', '#6393ff', '#9863ff'],
                    data: [41, 15, 6, 5, 2]
                }],

                // These labels appear in the legend and in the tooltips when hovering different arcs
                labels: ["Red", "Yellow", "Blue"]
            }
        };
    },
    methods: {
        initStatsCards() {
            this.statsCards = [
                {
                    title: this.dashboardData.totalApplicants.toString(),
                    subTitle: 'Registered Applicants',
                    type: 'info',
                    icon: 'tim-icons icon-single-02',
                    footer: '***'
                },
                {
                    title: this.dashboardData.totalSubmitted.toString(),
                    subTitle: 'Submitted Applications',
                    type: 'primary',
                    icon: 'tim-icons icon-send',
                    footer: '***'
                },
                {
                    title: this.dashboardData.totalDrafts.toString(),
                    subTitle: 'Draft Applications',
                    type: 'primary',
                    icon: 'tim-icons icon-watch-time',
                    footer: '***'
                },
                {
                    title: this.dashboardData.totalNonEligible.toString(),
                    subTitle: "Non-eligible Applications",
                    type: "warning",
                    icon: "tim-icons icon-simple-remove",
                    footer: "***",
                    showIf: true
                },
                {
                    title: this.dashboardData.totalAwarded.toString(),
                    subTitle: "Awarded Applications",
                    type: "info",
                    icon: "tim-icons icon-check-2",
                    footer: "***",
                    showIf: this.filters.stage !== 'Concept Note'
                },
                {
                    title: this.dashboardData.totalApplicationsWithCoApplicant.toString(),
                    subTitle: "Applications with a co-applicant",
                    type: "info",
                    icon: "tim-icons icon-check-2",
                    footer: "***",
                    showIf: this.filters.stage !== 'Concept Note'
                },
                {
                    title: this.dashboardData.totalThresholds.above.toString(),
                    subTitle: "Above the threshold",
                    type: "primary",
                    icon: "tim-icons icon-chart-bar-32",
                    footer: "***",
                    showIf: this.filters.stage !== 'Concept Note'
                },
                {
                    title: this.dashboardData.totalThresholds.below.toString(),
                    subTitle: "Below the threshold",
                    type: "primary",
                    icon: "tim-icons icon-chart-bar-32",
                    footer: "***",
                    showIf: this.filters.stage !== 'Concept Note'
                },
                {
                    title: this.dashboardData.totalAmounts.lessThan50k.toString(),
                    subTitle: 'Up to €55,000',
                    type: 'primary',
                    icon: 'tim-icons icon-coins',
                    footer: '***'
                },
                {
                    title: this.dashboardData.totalAmounts.lessThan100k.toString(),
                    subTitle: '€55,000',
                    type: 'primary',
                    icon: 'tim-icons icon-coins',
                    footer: '***'
                },
                // {
                //   title: this.dashboardData.totalAmounts.lessThan40k.toString(),
                //   subTitle: 'Less Than 40.000 €',
                //   type: 'primary',
                //   icon: 'tim-icons icon-coins',
                //   footer: '***'
                // },
            ]
        },
        initCountryMap() {

        },
        initDashboard() {
            let vm = this;
            DashboardService.getDashboardData(vm.filters).then(function (response) {
                vm.dashboardData = response.data;
                vm.initStatsCards()
                vm.initCountryMap();
            });

            RegionService.getRegionsWithCountries().then(function (response) {
                vm.regions = response.data;
            });

            vm.getFilters();
        },
        getFilters() {
            let vm = this;

            DashboardService.getFilters().then(function(response) {
                vm.filterOptions = response.data;
            });
        },
        applyFilters() {
            this.initDashboard();
        },
        exportExcell()
        {
            const vm = this;
            let url = process.env.VUE_APP_ROOT_API + '/dashboard/export?';
            let attrs = [];

            if (vm.filters.year)
            {
                attrs.push('year=' + vm.filters.year);
            }

            if (vm.filters.regionId)
            {
                attrs.push('region_id=' + vm.filters.regionId);
            }

            if (vm.filters.stage)
            {
                attrs.push('stage=' + vm.filters.stage);
            }

            url = url + attrs.join('&');

            console.log(url);

            window.location = url;
        },
    },
    mounted() {

    },
    beforeMount() {
        this.initDashboard();
    },
    beforeDestroy() {
    }
};
</script>
<style></style>
